<template>
  <v-row>
    <blockquote class="ma-0 pa-0">
      <p class="text-body-2 font-weight-light font-italic white--text my-0">
        {{quotes.text}}
      </p>
      <p  class="author text-body-2 font-weight-light font-italic white--text my-0 pt-2 pb-0 pr-5 pr-md-0">
        {{quotes.author}}
      </p>
    </blockquote>
  </v-row>
</template>
<script>
export default {
  props:{
    quotes:Object
  },
}
</script>
<style  scoped>
  .author{
    text-align: right;
  }
</style>
